export default __webpack_public_path__ + "static/media/projector.3ac0ffbd.svg";